(function ($) {
  if ($('form#mediaUploadForm').length) {
    /**
     * Define variables
     */
    var mediaUploadForm = $('form#mediaUploadForm');
    var mediaInput = mediaUploadForm.find('#mediaInput');
    var mediaInputError = mediaInput.parent().find('.error');
    var mediaList = mediaUploadForm.find('#mediaList');
    var submitButton = mediaUploadForm.find('input[type="submit"]');
    var loader = mediaUploadForm.find('.ajax-loader');
    var responseOutput = mediaUploadForm.find('.response-output');
    var fileIndex = 0;

    /**
     *  File validation
     *  @param  {object}      file  File object
     *  @return {bool|string}       True if file is valid, string (error message) if not
     */
    function validateFile(file) {
      if (typeof file === 'object') {
        if (!file.name.match(/.(jpg|jpeg|png|gif|bmp|doc|docx|pdf)$/i)) {
          return theme_js_vars.translations['file_wrong_format'];
        } else if (file.size > theme_js_vars.file_size_limit) {
          return theme_js_vars.translations['file_too_large'];
        } else {
          return true;
        }
      } else {
        return theme_js_vars.translations['form_submit_fail'];
      }
    }

    /**
     *  Add file to list
     */
    function addFileToList(input, filename) {
      if (!input || !filename) return false;

      var item = '';
      item += '<div id="item-' + fileIndex + '" class="item">';
      item += '<div class="item__header">';
      item += '<p class="item__name">' + filename + '</p>';
      item += '<button type="button" class="item__remove">';
      item += theme_js_vars.translations['remove'];
      item += '</button>';
      item += '</div>';
      item += '<span class="item__error"></span>';
      item += '<span class="ajax-loader"></span>';
      item += '</div>';

      mediaList.append(item);
      mediaList.find('#item-' + fileIndex).append(input);

      mediaList.find('.item__remove').on('click', function () {
        if (!mediaUploadForm.hasClass('sending')) {
          $(this).parent().parent().remove();
        }
      });

      return true;
    }

    /**
     * File input change handler
     */
    function fileInputChangeHandler(fileInput) {
      var file = fileInput[0].files[0];
      mediaInputError.text('');
      responseOutput.text('');
      responseOutput.removeClass('error');

      if (file !== undefined) {
        var isFileValid = validateFile(file);

        if (isFileValid !== true) {
          mediaInputError.text(isFileValid);
          fileInput.val('');
        } else {
          var clonedInput = fileInput.clone();

          clonedInput.insertAfter(fileInput);
          clonedInput.val('');
          
          fileInput.attr('id', 'media-' + fileIndex);
          fileInput.attr('name', 'media-' + fileIndex);
          fileInput.css('display', 'none');

          addFileToList(fileInput, file.name);

          clonedInput.on('change', function () {
            fileInputChangeHandler(clonedInput);
          });

          fileIndex += 1;

          $(this).val('');
        }
      }
    }

    mediaInput.on('change', function () {
      fileInputChangeHandler($(this));
    });

    /**
     * Form change handler
     */
    mediaUploadForm.on('change', function (e) {
      if (mediaUploadForm.hasClass('sending')) {
        e.preventDefault();
      } else {
        if (mediaList.find('.item').length) {
          submitButton.prop('disabled', false);
        } else {
          submitButton.prop('disabled', true);
        }
      }
    });

    /**
     * Submit button click handler
     */
    submitButton.on('click', function (e) {
      e.preventDefault();
      loader.css('visibility', 'visible');
      mediaUploadForm.addClass('sending');
      setTimeout(function () {
        /**
         * A delay is added to fix the loader issue.
         * Otherwise, the loader isn't displayed until the first file has been
         * successfully uploaded.
         */
        mediaUploadForm.trigger('submit');
      }, 5);
    });

    /**
     * Form submit handler
     */
    mediaUploadForm.on('submit', function (e) {
      e.preventDefault();
      mediaUploadForm.addClass('sending');
      loader.css('visibility', 'visible');
      submitButton.prop('disabled', true);
      mediaInputError.text('');
      responseOutput.text('');
      responseOutput.removeClass('error');
      fileUploadSuccess = false;

      if (mediaList.find('.item').length) {
        function delay(n) {
          return new Promise(function (resolve) {
            setTimeout(resolve, n);
          });
        }

        var file_ids = [];

        var items = mediaList.find('.item');
        items.find('input, button, select').prop('disabled', true);

        async function loop() {
          var status_code = 500;

          var items = mediaList.find('.item');
          var file_upload_success = false;

          for (var i = 0; i < items.length; i++) {
            var formIsValid = true;

            var item = $(items[i]);
            var itemError = item.find('.item__error');
            var file = item.find('input[type="file"]')[0].files[0];

            item.addClass('loading');
            itemError.text('');

            var isFileValid = validateFile(file);
            if (isFileValid !== true) {
              formIsValid = theme_js_vars.translations['file_upload_fail'];
              item.remove();
            }

            if (formIsValid !== true) {
              item.removeClass('loading');
              itemError.text(formIsValid);
            } else {
              var fd = new FormData();
              fd.append('action', 'imedia_media_upload_form');
              fd.append('file', file);

              $.ajax({
                async: false,
                type: 'POST',
                url: theme_js_vars.ajax_url,
                data: fd,
                processData: false,
                contentType: false,
                success: function (response, textStatus, xhr) {
                  fileUploadSuccess = true;
                  file_ids.push(response.attach_id);
                  item.remove();
                },
                fail: function (error) {
                  console.log(error);
                  item.removeClass('loading');
                  itemError.text(error);
                  responseOutput.addClass('error');
                  responseOutput.text(
                    theme_js_vars.translations['form_submit_fail'],
                  );
                },
              });
            }

            if (i == items.length - 1) {
              mediaUploadForm.removeClass('sending');
              submitButton.prop('disabled', false);
              items.find('input, button, select').prop('disabled', false);

              if (fileUploadSuccess) {
                file_upload_success = true;
                responseOutput.text(
                  theme_js_vars.translations['file_upload_success'],
                );
              } else {
                responseOutput.addClass('error');
                responseOutput.text(
                  theme_js_vars.translations['form_submit_fail'],
                );
              }
            } else {
              await delay(200);
            }
          }

          if (file_upload_success) {
            // Send email to admin
            $.ajax({
              url: theme_js_vars.ajax_url,
              type: 'POST',
              data: {
                action: 'imedia_media_upload_mail',
                files: file_ids,
              },
              fail: function (error) {
                console.log(error);
              },
            });
          }

          loader.css('visibility', 'hidden');
        }

        loop();
      } else {
        mediaUploadForm.removeClass('sending');
        loader.css('visibility', 'hidden');
      }
    });
  }
})(jQuery);
